export const VIDEOS_PATH = '/videos';

export const VIDEO_UPLOAD_PATH = `${VIDEOS_PATH}/upload`;

export const VIDEO_QUERY_PARAM = 'video';
